export const config = {
  mapboxToken: 'pk.eyJ1IjoicXJvaGxmIiwiYSI6Ik9NM256cUEifQ.q8UxPJGRS3bAKcCoLwZdzA'
}
